import React from 'react'
import uniq from 'lodash/uniq'
import { connect } from 'react-redux'
import { Flex, Box } from 'reflexbox'
import { MenuItem, Spinner, Icon, Tag } from '@blueprintjs/core'

import DeviceFilterSelect from './DeviceFilterSelect'
import InputSelect from 'src/components/InputSelect'
import * as filterModules from 'src/store/modules/cmdb/filters'

import './style.scss'

const menuItemRenderer = (item, { handleClick, modifiers }) => {
    return (
        <MenuItem
            active={modifiers.active}
            key={item.id}
            onClick={handleClick}
            text={item.name}
            label={item.id}
        />
    )
}

const inputValRender = () => {
    return ''
}

class ConfigurationItems extends React.Component {
    handleFilterSelect = (filterId) => (item) => {
        const { selectFilter, selected } = this.props
        selectFilter(
            filterId,
            uniq([
                ...selected.values,
                selected.id !== 'cmdb_class' ? item.id : item.name,
            ])
        )
    }
    handleFilterDeselect = (filterId) => (e, { value }) => {
        const { selectFilter, filters } = this.props
        selectFilter(
            filterId,
            filters
                .filter((s) => s.id === filterId)[0]
                .values.filter((v) => v !== value)
        )
    }
    render() {
        const { loading, selected, filters, results, searchFilter } = this.props
        return (
            <Flex w={1} wrap>
                <Box w={1} p={2}>
                    <Flex w={1}>
                        <Box ml="auto">
                            <DeviceFilterSelect />
                        </Box>
                        <Box ml={2} mr="auto" w={4 / 10}>
                            <InputSelect
                                inputProps={{
                                    leftIcon: 'search',
                                    round: true,
                                    rightElement: loading && (
                                        <Spinner size={Icon.SIZE_STANDARD} />
                                    ),
                                }}
                                popoverProps={{
                                    targetClassName: 'device-filter-input',
                                    minimal: true,
                                }}
                                resetOnSelect={true}
                                resetOnClose={true}
                                inputValueRenderer={inputValRender}
                                onQueryChange={searchFilter}
                                onItemSelect={this.handleFilterSelect(
                                    selected.id
                                )}
                                items={results}
                                itemRenderer={menuItemRenderer}
                                noResults={
                                    <MenuItem disabled text="No Results" />
                                }
                            />
                        </Box>
                    </Flex>
                    <Flex w={1}>
                        <Box mx="auto">
                            {filters.map((f) =>
                                f.values.map((value) => (
                                    <Tag
                                        round
                                        key={value}
                                        onRemove={this.handleFilterDeselect(
                                            f.id
                                        )}
                                        style={{ margin: 5 }}
                                        value={value}
                                    >
                                        {f.name}: {value}
                                    </Tag>
                                ))
                            )}
                        </Box>
                    </Flex>
                </Box>
            </Flex>
        )
    }
}

export default connect(
    (state) => ({
        results: filterModules.getResultsForFilter(state),
        loading: filterModules.getLoadingForFilter(state),
        selected: filterModules.getFilterById(
            state,
            state.cmdb.filters.selected
        ),
        filters: filterModules.getFilters(state),
    }),
    {
        searchFilter: filterModules.searchFilter,
        selectFilter: filterModules.setFilterValue,
    }
)(ConfigurationItems)
